// extracted by mini-css-extract-plugin
export var wrapper = "history-list-module--wrapper--ahhwj";
export var history = "history-list-module--history--Byu0t";
export var carousel = "history-list-module--carousel--wuAmC";